import { useEffect } from "react";
import { atom, useAtom } from "jotai";

type FrontendUpdateAvailableInput = {
  latestVersion?: string | null;
  frontendVersion?: string | null;
};

export const frontendUpdateAvailableAtom = atom(false);

export const useFrontendUpdateAvailable = ({
  latestVersion,
  frontendVersion,
}: FrontendUpdateAvailableInput) => {
  const [updateAvailable, setUpdateAvailable] = useAtom(
    frontendUpdateAvailableAtom,
  );

  useEffect(() => {
    if (latestVersion && frontendVersion && latestVersion !== frontendVersion) {
      setUpdateAvailable(true);
    }
  }, [frontendVersion, latestVersion, setUpdateAvailable]);

  return updateAvailable;
};
